import { IClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';

import { PackageType } from '../../../models/multi-item/multi-item-types';
import { SearchClickstreamPageNameDetailed, SearchMapClickstreamPageNameDetailed } from '../../../constants/pages';

import { View, ViewTracker } from '../../contexts/viewTracker';

export function changeView(tracker: IClickstreamAnalytics, viewTracker: ViewTracker, nextView: View, packageType?: PackageType) {
  const { view, setView } = viewTracker;

  if (nextView !== view) {
    setView(nextView);

    const pageNameSet = nextView === View.LISTINGS ? SearchClickstreamPageNameDetailed : SearchMapClickstreamPageNameDetailed;

    const pageNameDetailed = packageType ? pageNameSet[packageType] : pageNameSet.SA;

    tracker.reset({
      data: {
        // eslint-disable-next-line camelcase
        experience: { page_name_detailed: pageNameDetailed },
      },
      config: { isEgClickstream: true },
    });
  }
}
